import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store'
import vant from 'vant'
import 'vant/lib/index.css'
import './assets/styles/common.less'

import plugins from './plugins'
import i18n from './lang/index.js'

import vConsole from './plugins/vconsole'

const app = createApp(App);
app.use(router)
app.use(store)
app.use(vant)
app.use(plugins)
app.use(i18n)
app.mount('#app')